import React from 'react'
import { Outlet } from 'react-router-dom'
import ajaxAddress from 'src/base/ajaxaddress'
import { setOrders, sortComplexOrder } from 'src/features/orders/orderSlice'
import { useSelector, useDispatch } from 'react-redux'
import { CCol, CModal, CModalBody, CRow, CSpinner } from '@coreui/react'
import './pageLoader.css'
import { setSelects } from 'src/features/select/selectSlice'
import { setConfigs } from 'src/features/configs/configSlice'
export default function AppDefaultRoute() {
  const user = JSON.parse(localStorage.getItem('user-info'))
  const dispatch = useDispatch()
  const [show, setShow] = React.useState(true)
  React.useEffect(() => {
    let url = ''
    if (user.user.role == 'doorInstaller') url = ajaxAddress + 'installDoor'
    else url = ajaxAddress + 'orders'
    fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + user.token,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        dispatch(setOrders(json.orders))
        dispatch(setSelects(json.selects))
        dispatch(setConfigs(json.configs))
        setShow(false)
      })
      .catch((e) => {
        console.log(e, 'this is an error')
        setShow(false)
      })
    return
  }, [])
  return (
    <>
      <CModal
        visible={show}
        aria-labelledby="LiveDemoExampleLabel"
        color="primary"
        backdrop="static"
        size="sm"
        className="loaderModal center"
      >
        <CModalBody>
          <CRow>
            <CCol className="text-center">
              <CSpinner color="info" />
            </CCol>
          </CRow>
        </CModalBody>
      </CModal>
      <Outlet />
    </>
  )
}
